const addDeviceDialogStyle = (theme) => ({
	dialogContainer: {
		minHeight: '500px',
	},
	container: {
		textAlign: 'center',
		margin: '30px',
		display: 'flex',
		justifyContent: 'center',
		'& .dataContainer': {
			width: '300px',
		},
	},
	productContainer: {
		margin: '15px 60px 30px 60px',
	},
	titleContainer: {
		marginTop: '15px',
	},
	input: {
		'& > span > div > .MuiInputLabel-root': {
			fontSize: 16,
			'&.MuiInputLabel-shrink': {
				fontSize: '14px!important',
			},
		},
		'& > span > div > div > div': {
			fontSize: 16,
		},
		[theme.breakpoints.down('xs')]: {
			width: '80%',
		},
	},
	alternativeUnselected: {
		'& > div > div': {
			paddingBottom: '0px',
		},
		'& p': {
			color: 'rgba(0, 0, 0, 0.65) !important',
		},
	},
	alternativeSelected: {
		'& > div > div': {
			paddingBottom: '0px',
			borderBottom: '1px solid rgba(0, 0, 0, 0.65)',
		},
		'& p': {
			color: 'rgba(0, 0, 0, 1) !important',
		},
	},
	right: {
		textAlign: 'right',
		margin: '30px',
	},
	nextButton: {
		width: 120,
	},
	errorContainer: {
		marginBottom: '15px',
	},
});

export default addDeviceDialogStyle;
